/** INIT locales and i18n translations

* @Author: Tom Voorneveld <root>
* @Date:   2016-10-18T22:00:06+02:00
* @Email:  tom@lorinthe.com
* @Project: Qrespi
  @Last modified by:   tom
  @Last modified time: 2019-06-08T11:19:29+02:00
* @License: Copyright Lorinthe BV, The Netherlands. All rights reserved

  See https://kazupon.github.io/vue-i18n/

  // Language and locales
  import i18n from '@/lib/lang'
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  Use in javascript:
    new Vue({
      methods: {
        getMessage: function (key) {
          return this.$t(key)
        }
      }
    })

*/

import store from '@/store'
// import CONFIG from '@/config/settings'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Log from '@/lib/log'

import { en } from '@/assets/lang/en.js'
import { nl } from '@/assets/lang/nl.js'
Vue.use(VueI18n)

// Files to load from lang folder:
const messages = {
  nl: nl,
  en: en
}

// const loadLocales = CONFIG.installed_languages
// loadLocales.forEach(function (lang) {
//   let langObj = require(`./${lang}.js`)
//   messages[lang] = langObj
// })

Vue.config.lang = store.getters['app/setting']('language')

// also update the <html lang="en"> for Google and other crawlers
document.documentElement.setAttribute('lang', Vue.config.lang)

Log.n(`Language = ${Vue.config.lang}`)

// get locaiton if user switches it on
store.subscribe((mutation, state) => {
  if (mutation.type.includes('app/setting') &&
  mutation.payload.set === 'language' &&
  mutation.payload.value) {
    Vue.config.lang = mutation.payload.value
    // this.$i18n.locale = Vue.config.lang
    i18n.locale = Vue.config.lang
    // this.setHtmlLangAttr(Vue.config.lang)
    document.documentElement.setAttribute('lang', Vue.config.lang)
  }
})

const i18n = new VueI18n({
  locale: Vue.config.lang, // set locale
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages // set locale messages
})

export default i18n
